import axios from "axios";
import router from "../router/index";
import $ from "jquery";
import Vue from "vue";
const voucher = {
  state: () => ({
    items: [],
    filter: {},
    templateID: null,
    modalVisible: false,
    ids: [],
    total: 0,
    type: null,
  }),
  actions: {
    async sendVoucher(store, payload) {
      store.state.filter = payload.filter;
      store.state.ids = payload.ids;
      store.state.modalVisible = true;
    },
  },
  getters: {},
};
export default voucher;



// WEBPACK FOOTER //
// ./src/store/voucher.js